import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  searchUser: {
    id: null,
    name: null,
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
